module.exports = __webpack_public_path__ + "static/media/close.b284e289.svg";